'use client';

import * as SliderPrimitive from '@radix-ui/react-slider';

import * as React from 'react';

import { cn } from '@/utils/styles';

const Slider = React.forwardRef<
	React.ElementRef<typeof SliderPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
		thumbClassName?: string;
		trackClassName?: string;
		rangeClassName?: string;
	}
>(({ className, thumbClassName, trackClassName, rangeClassName, ...props }, ref) => {
	return (
		<SliderPrimitive.Root
			ref={ref}
			className={cn('relative flex w-full touch-none select-none items-center', className)}
			{...props}
		>
			<SliderPrimitive.Track
				className={cn(
					'relative h-2 w-full grow overflow-hidden rounded-full bg-secondary',
					trackClassName
				)}
			>
				<SliderPrimitive.Range className={cn('absolute h-full bg-primary', rangeClassName)} />
			</SliderPrimitive.Track>
			<SliderPrimitive.Thumb
				className={cn(
					'block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
					thumbClassName
				)}
			/>

			{Array.isArray(props?.value) && props?.value?.length > 1
				? new Array(props?.value?.length - 1)?.fill(1)?.map((_, i) => (
						<SliderPrimitive.Thumb
							key={i}
							className={cn(
								'block h-5 w-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
								thumbClassName
							)}
						/>
					))
				: null}
		</SliderPrimitive.Root>
	);
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
